// TODO:this function is intended to force the css highlighting only should be removed when
// this https://github.com/styled-components/vscode-styled-components/issues/52 is merged
import _zip from "lodash/zip";
import _flatten from "lodash/flatten";
const injectGlobal = (s, ...keys) => _flatten(_zip(s, keys || []))
export default injectGlobal;